import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { WarehouseTransfers_ModuleContextService } from './WarehouseTransfers.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_orderline_total_amount_widget_ComponentContextService {
  private readonly moduleContext: WarehouseTransfers_ModuleContextService;

  constructor(moduleContext: WarehouseTransfers_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'orderline_total_amount_widget',
      type: ComponentType.widget
    }
  }
}